import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { ExtendedFartherHoldingsArraySchema } from "../../DataLake/Types";
import { PhysicalAccountId, VirtualAccountId, } from "../../Types";
import ValidationError from "../../ZodError";
const ExpandOptionsEnum = z.enum(["securityDetails"]);
// Define the expand transform to handle both single value and array
const Expand = z
    .union([z.array(ExpandOptionsEnum), ExpandOptionsEnum.transform((v) => [v])])
    .optional();
export const QueryParams = z.object({
    virtualAccountIds: z.array(VirtualAccountId).optional(),
    physicalAccountIds: z.array(PhysicalAccountId).optional(),
    $expand: Expand,
});
export const Response = z.object({
    data: ExtendedFartherHoldingsArraySchema,
});
export const url = (clientId, queryParams) => {
    const queryString = new URLSearchParams();
    if (queryParams !== null) {
        if (queryParams.virtualAccountIds) {
            queryParams.virtualAccountIds.forEach((id) => {
                queryString.append("virtualAccountIds", id);
            });
        }
        if (queryParams.physicalAccountIds) {
            queryParams.physicalAccountIds.forEach((id) => {
                queryString.append("physicalAccountIds", id);
            });
        }
        if (queryParams.$expand) {
            queryParams.$expand.forEach((expand) => {
                queryString.append("$expand", expand);
            });
        }
    }
    const queryStringValue = queryString.toString();
    const searchParams = queryStringValue === "" ? "" : `?${queryStringValue}`;
    const url = environment() === "PROD"
        ? `https://middleware.prod.farther.com/account/holdings/${clientId}`
        : `https://middleware.uat.farther.com/account/holdings/${clientId}`;
    return `${url}${searchParams}`;
};
export default async function getAccountHoldingsV2(clientId, queryParams, config) {
    const fullUrl = url(clientId, queryParams);
    const { data } = await axios.get(fullUrl, {
        headers: {
            version: "20250408",
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data.data;
    }
    else {
        const errorMessage = `[${getAccountHoldingsV2.name}] Could not parse`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getAccountHoldingsV2.js.map